import { configureStore } from "@reduxjs/toolkit";
import { unstable_batchedUpdates } from '../reactBatchedUpdates';

import AuthReducer from './features/authSlice';
import JobReducer from './features/jobSlice';
import WorkerReducer from './features/workerSlice';
import PartnerReducer from './features/partnerSlice';
import TeamReducer from './features/teamSlice';
import ModelReducer from './features/modelSlice';
import ClientReducer from './features/clientSlice';
import DashboardReducer from '../reducers/dashboardReducer';
import SparePartReducer from './features/sparePartSlice';
import PaymentReducer from './features/paymentSlice';
import SubscriptionPaymentReducer from './features/subscriptionPaymentSlice';
import WebShopReducer from './features/webshopSlice';
import MarketingReducer from './features/marketingSlice';

// Mapiramo našu implementaciju u globalni objekat
// Ovo može pomoći u slučaju da react-redux traži funkciju kroz window/global
if (typeof window !== 'undefined') {
  window.reactDom = window.reactDom || {};
  window.reactDom.unstable_batchedUpdates = unstable_batchedUpdates;
}

export default configureStore({
  reducer:{
    auth: AuthReducer,
    job: JobReducer,
    worker: WorkerReducer,
    partner: PartnerReducer,
    team: TeamReducer,
    model: ModelReducer,
    client: ClientReducer,
    dashboard: DashboardReducer,
    spareParts: SparePartReducer,
    payment: PaymentReducer,
    subscriptionPayment: SubscriptionPaymentReducer,
    webshop: WebShopReducer,
    marketing: MarketingReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  })
});
